var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgCartIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0561 14.7708H2.44401C1.97203 14.7708 1.6101 14.3285 1.67675 13.8345L2.56258 7.26969C2.61683 6.86513 2.94389 6.5648 3.32984 6.5648H3.87467V8.206C3.87467 8.65897 4.22187 9.0266 4.64967 9.0266C5.07825 9.0266 5.42467 8.65897 5.42467 8.206V6.5648H10.0747V8.206C10.0747 8.65897 10.4219 9.0266 10.8497 9.0266C11.2783 9.0266 11.6247 8.65897 11.6247 8.206V6.5648H12.1703C12.5563 6.5648 12.8833 6.86513 12.9376 7.26969L13.8234 13.8345C13.89 14.3285 13.5281 14.7708 13.0561 14.7708ZM5.42462 4.10306C5.42462 2.74579 6.46778 1.64126 7.74963 1.64126C9.03226 1.64126 10.0746 2.46186 10.0746 4.10306V4.92366H5.42462V4.10306ZM15.4842 14.5386L14.3767 6.33257C14.2682 5.52428 13.6141 4.9236 12.8422 4.9236H11.6246V4.103C11.6246 1.6412 9.8863 0 7.74961 0C5.6137 0 3.87459 1.84061 3.87459 4.103V4.9236H2.89421C2.12308 4.9236 1.23183 5.52428 1.12255 6.33257L0.0158473 14.5386C-0.117453 15.5274 0.607175 16.412 1.55036 16.412H13.9496C14.8928 16.412 15.6175 15.5274 15.4842 14.5386Z",
    fill: "#222222"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCartIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/cart_icon.ba0a40af.svg";
export { ForwardRef as ReactComponent };